(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5585],{

/***/ 74026:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/write-for-graphcms",
      function () {
        return __webpack_require__(63187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ WriteForGraphCMS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17563);
/* harmony import */ var _components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1635);
/* harmony import */ var _components_HubSpotForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32472);
/* harmony import */ var _components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27910);
/* harmony import */ var _components_Hero__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52456);
/* harmony import */ var _components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89338);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67576);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __N_SSG = true;
function WriteForGraphCMS(param) {
    var page = param.page, hubspotForm = param.hubspotForm, preview = param.preview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), params = ref[0], setParams = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var query = query_string__WEBPACK_IMPORTED_MODULE_2__.parse(window.location.search);
        setParams(query || {});
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_Vanilla__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                size: "small",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hero__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _objectSpread({}, page))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                size: "small",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "md:-mx-6 md:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "md:w-1/2 md:px-6 lg:w-3/5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MarkdownRenderer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({}, page))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "my-12 md:w-1/2 md:px-6 lg:w-2/5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md:sticky md:top-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mb-4 md:-mt-12",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                level: 4,
                                                children: "Submit your pitch!"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                                className: "inline-block h-1 w-24 rounded border-0 bg-cornflower md:w-48"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HubSpotForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        params: params,
                                        form: hubspotForm
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,8009,2283,5343,1635,2456,9338,3458,9116,9774,2888,179], function() { return __webpack_exec__(74026); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);